import styled from 'styled-components';

export const Page = styled.div`
  width: 100%;
`;
